<mat-sidenav-container class="menu">
  <mat-sidenav #sidenav class="menu__side" mode="over" [autoFocus]="false">
    <header>
      <ng-container *ngIf="emailFromToken; else noToken">
        <article>
          <h4>{{ emailFromToken }}</h4>
        </article>
      </ng-container>
      <ng-template #noToken>
        <article *ngIf="user; else noUser">
          <img [src]="user.photoUrl" class="mat-icon menu__photo" />
          <h4>{{ user.fullName }}</h4>
          <h4>{{ user.email }}</h4>
        </article>
        <ng-template #noUser>
          <article>
            <mat-icon svgIcon="photo"></mat-icon>
            <h4>Grid Dynamics Employee</h4>
            <h4>n.surname@griddynamics.com</h4>
          </article>
        </ng-template>
      </ng-template>
    </header>

    <main>
      <ng-container *ngIf="!user">
        <mat-action-list class="menu__side__admin">
          <a
            mat-list-item
            class="link"
            href="{{ menuElement.route }}"
            target="_blank"
            rel="noopener noreferrer"
            (click)="sideMenuService.toggle()"
            *ngFor="let menuElement of defaultMenuContent"
          >
            <mat-icon class="icon" [svgIcon]="menuElement.iconName"></mat-icon>
            {{ menuElement.text }}
          </a>
        </mat-action-list>

        <mat-divider></mat-divider>

        <mat-action-list class="menu__side__auth">
          <button mat-list-item (click)="onLogout()">
            <mat-icon class="icon" svgIcon="logout"></mat-icon>
            Log out
          </button>
        </mat-action-list>
      </ng-container>

      <ng-container *ngIf="user">
        <ng-container *ngIf="isAdmin">
          <mat-action-list class="menu__side__admin">
            <button
              [ngClass]="{ 'menu--active': isRouteActive(menuElement.route) }"
              mat-list-item
              (click)="sideMenuService.toggle()"
              routerLink="{{ menuElement.route }}"
              *ngFor="let menuElement of adminMenuContent"
            >
              <mat-icon class="icon" [svgIcon]="menuElement.iconName"></mat-icon>
              {{ menuElement.text }}
            </button>
          </mat-action-list>
          <mat-divider></mat-divider>
        </ng-container>

        <mat-action-list class="menu__side__user">
          <button
            [ngClass]="{ 'menu--active': isRouteActive(menuElement.route) }"
            mat-list-item
            (click)="sideMenuService.toggle()"
            routerLink="{{ menuElement.route }}"
            *ngFor="let menuElement of userMenuRoutesContent"
          >
            <mat-icon class="icon" [svgIcon]="menuElement.iconName"></mat-icon>
            {{ menuElement.text }}
          </button>
          <a
            mat-list-item
            class="link"
            href="{{ menuElement.route }}"
            target="_blank"
            rel="noopener noreferrer"
            (click)="sideMenuService.toggle()"
            *ngFor="let menuElement of userMenuLinksContent"
          >
            <mat-icon class="icon" [svgIcon]="menuElement.iconName"></mat-icon>
            {{ menuElement.text }}
          </a>
        </mat-action-list>

        <mat-divider></mat-divider>

        <mat-action-list class="menu__side__auth">
          <button mat-list-item (click)="onLogout()">
            <mat-icon class="icon" svgIcon="logout"></mat-icon>
            Log out
          </button>
        </mat-action-list>
      </ng-container>
    </main>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="menu__content">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
